import { useIntl } from 'react-intl';

import { extractLanguage } from '@/configuration/lang/lang';
import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import {
    MAN_CHARGE_AND_GO,
    PRIVACY_POLICY_URL,
    RIO_PRICE_LIST_URL,
    TCS,
    TCS_PRIVACY_POLICY_URL,
} from '@/lib/constants';
import { formatUrl, t } from '@/lib/utils';

export const PolicyAndPricingLinks = () => {
    const intl = useIntl();
    const userLanguage = extractLanguage(intl.locale);
    const debugConfig = createDebugConfig();

    const handlePriceListClick = () => {
        trackCustomEvent(
            'open_price_list',
            {
                trigger: 'click',
                flow_name: 'onboarding',
                element_name: 'price_list_link',
            },
            debugConfig
        );
    };

    return (
        <div className='display-flex flex-column justify-content-end align-items-end margin-top-10'>
            <a
                className='text-color-primary'
                href={formatUrl(RIO_PRICE_LIST_URL, userLanguage)}
                target='_blank'
                rel='noreferrer'
                onClick={handlePriceListClick}
            >
                {t('general.viewPricing')}
            </a>
            <a
                className='text-color-primary'
                href={formatUrl(PRIVACY_POLICY_URL, userLanguage)}
                target='_blank'
                rel='noreferrer'
            >
                {MAN_CHARGE_AND_GO} - {t('general.privacyNotice')}
            </a>
            <a className='text-color-primary' href={TCS_PRIVACY_POLICY_URL} target='_blank' rel='noreferrer'>
                {TCS} - {t('general.privacyNotice')}
            </a>
        </div>
    );
};
